import React from "react";
import { Icon as CustomIcon } from "@iconify/react";

const Icon = ({ icon, className, width = "20", rotate, hFlip, vFlip, onClick }) => {
  return (
    <CustomIcon
      width={width}
      rotate={rotate}
      hFlip={hFlip}
      icon={icon}
      className={className}
      vFlip={vFlip}
      onClick={onClick ? onClick : null}
    />
  );
};

export default Icon;
